module.exports = __webpack_public_path__ + "img/bet365-logo.e3f50d5e.svg";